/**
 * A busca do portal (`/resultado-busca`), já traduzida do contrato público da API
 * (`GET api/sai/cartaservico/publico/busca`).
 *
 * Os tipos `*Response` espelham o JSON do back-end e param no `BuscaPublicaService`: a
 * tela só conhece `ResultadoBusca`, que junta os registros da API e as páginas fixas do
 * portal na mesma forma.
 */

/** As fontes da rota pública. Pedido do e-SIC e manifestação ficam fora: são dados de cidadão. */
export type TipoResultadoBuscaApi = 'Servico' | 'CategoriaServico' | 'Noticia';

/** Um registro encontrado, como vem de `GET /publico/busca`. Sem rota: o portal a monta. */
export interface ItemBuscaPublicaResponse {
  tipo: TipoResultadoBuscaApi;
  codigo: number;
  /** O nome do serviço ou da categoria; o título da notícia. */
  titulo: string;
  /** Resumo, descrição ou subtítulo, em até 200 caracteres; pode vir nulo. */
  descricao: string | null;
  /** Atualização do serviço e da categoria; publicação da notícia. */
  data: string;
  /** Só na notícia. */
  slug: string | null;
  /** Só no serviço, na ordem cadastrada. */
  tiposAtendimento: readonly string[];
}

export interface BuscaPublicaResponse {
  termo: string;
  /** Tudo o que casou, mesmo além do limite pedido. */
  total: number;
  itens: readonly ItemBuscaPublicaResponse[];
}

/** As abas da tela: as três fontes da API mais as páginas fixas do portal. */
export type CanalResultado = 'servicos' | 'categorias' | 'noticias' | 'paginas';

export interface CanalOpcao {
  id: CanalResultado;
  rotulo: string;
}

export const CANAIS: readonly CanalOpcao[] = [
  { id: 'servicos', rotulo: 'Serviços' },
  { id: 'categorias', rotulo: 'Categorias' },
  { id: 'noticias', rotulo: 'Notícias' },
  { id: 'paginas', rotulo: 'Páginas do portal' },
];

/** Um card da tela de resultado, venha da API ou do catálogo de páginas. */
export interface ResultadoBusca {
  /** Único entre canais: `servico-42`, `noticia-7`, `pagina-ouvidoria`. */
  id: string;
  canal: CanalResultado;
  titulo: string;
  descricao: string;
  /** Os chips do card: tipos de atendimento, data da notícia, "Página do portal"… */
  destaques: readonly string[];
  link: string;
  /** O título começa com o termo: ganha o selo "Mais relevante". */
  maisRelevante: boolean;
}
